<template>
  <div class="page">
    <Header />
        <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from '@district/components/common/Header.vue'
import Footer from '@district/components/common/Footer.vue'
export default {
    components: {
        Header,
        Footer
    },
}
</script>

<style lang="scss" scoped>
.page{
    width: 100%;
    color: #333333;
}
</style>


// WEBPACK FOOTER //
// src/district/views/Home.vue